// app/plugins/userinit.client.ts - 全局初始化用户信息（所有页面）
// 作用：
// - 应用在客户端启动时恢复登录信息并尝试从 /usermix/user_info 拉取资料与会员配额
// - 避免与 Header 重复：当已有加载完成或正在加载时不再触发

export default defineNuxtPlugin(() => {
  if (import.meta.server) return
  const userStore = useUserStore()

  // 恢复本地登录态
  try { userStore.initFromStorage() } catch {}

  // 已登录则尝试拉取用户信息（避免重复请求）
  if (userStore.isLoggedIn && !userStore.userLoaded && !userStore.userLoading) {
    try { userStore.fetchUserInfoFromUserMix() } catch {}
  }
})

